import React, { useEffect, useState } from "react";
import { scrollToSection } from "../lib/lenis";

const SECTIONS = [
  { id: "about", label: "About" },
  { id: "experience", label: "Experience" },
  { id: "education", label: "Education" },
  { id: "projects", label: "Projects" },
  { id: "skills", label: "Skills" },
  { id: "contact-me", label: "Contact" },
];

// Fixed dot rail on the right edge showing where you are in the journey
// (desktop only — too cramped on mobile).
export default function ScrollProgressDots() {
  const [active, setActive] = useState("about");

  useEffect(() => {
    let ticking = false;
    const update = () => {
      ticking = false;
      // Short final sections never cross the marker before scroll runs out,
      // so bottom-of-page always counts as the last section.
      const atBottom =
        window.scrollY + window.innerHeight >=
        document.documentElement.scrollHeight - 4;
      if (atBottom) {
        setActive(SECTIONS[SECTIONS.length - 1].id);
        return;
      }
      const marker = window.scrollY + window.innerHeight * 0.4;
      let current = SECTIONS[0].id;
      for (const { id } of SECTIONS) {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= marker) current = id;
      }
      setActive(current);
    };
    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      aria-label="Section navigation"
      className="fixed right-5 top-1/2 z-40 hidden -translate-y-1/2 flex-col items-center gap-4 lg:flex"
    >
      {SECTIONS.map(({ id, label }) => {
        const isActive = active === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => scrollToSection(id, -80)}
            aria-label={label}
            className="group relative flex items-center"
          >
            <span className="text-biolum-green pointer-events-none absolute right-5 whitespace-nowrap font-mono text-xs uppercase tracking-widest opacity-0 transition-opacity duration-200 group-hover:opacity-100">
              {label}
            </span>
            <span
              className={`block h-2.5 w-2.5 rounded-full border transition-all duration-300 ${
                isActive
                  ? "bg-biolum-green border-biolum-green scale-125 shadow-[0_0_10px_rgba(100,255,218,0.8)]"
                  : "border-biolum-green/40 bg-transparent group-hover:border-biolum-green"
              }`}
            />
          </button>
        );
      })}
    </nav>
  );
}
